module.exports = __webpack_public_path__ + "img/brands-wasa-header.jpg?33cdd6e585fb4e46e28a69210d999513";